import { createTheme } from '@mui/material'
import { defaultColors } from '../../../../infrastructure/materialUiThemeProvider'

export let customTimePickerTheme = createTheme({
    palette: {},
    components: {
        //@ts-ignore
        MuiPickersToolbar: {
            styleOverrides: {
                root: {
                    backgroundColor: defaultColors.darkBlue.main.color,
                    color: 'white',
                    '& .MuiTypography-root': {
                        color: 'white',
                    },
                },
            },
        },
        MuiPickersToolbarText: {
            styleOverrides: {
                root: {
                    color: 'rgba(255,255,255,0.6)',
                    '&.Mui-selected': {
                        color: 'white !important',
                    },
                },
            },
        },
    }
})